import range from 'lodash/range'
import type moment from 'moment'

/*
  rangeByDay takes two dates in moment format and returns
  an array of dates in moment format, one for each day between
  start and end, inclusive.
*/
export default function rangeByDay(start: moment.Moment, end: moment.Moment): moment.Moment[] {
  const diff = Math.abs(start.diff(end, 'day')) + 1

  return range(diff).map((i) => start.clone().add(i, 'day'))
}
